import vNumber from '../directives/v-number'
import vScrollEnd from '../directives/v-scroll-end'
import vWatermark from '../directives/v-watermark'

export function registerDirectives(Vue) {
  Vue.directive('number', vNumber)
  Vue.directive('scrollEnd', vScrollEnd)
  Vue.directive('watermark', vWatermark)
}
